module.exports = __webpack_public_path__ + "img/catalog.30fe7ad4.svg";